import { Box } from '@mui/material';

// ------------------------------------------------------------------
// SAMPLE DATA ONLY.
// Central does not have these values yet (next phase: city field, venue sync heartbeat,
// biometric upload flag, attended count).
// Every value from here is shown with <SampleValue> (lighter color).
// When real data is available, replace getSampleCenterFields with the API fields and remove SampleValue usages.
// ------------------------------------------------------------------

export const getSampleCenterFields = (center, index) => ({
    attended: center.present,
    syncOn: index % 3 !== 2,
    biometricUploaded: 0,
});

// PLACEHOLDER: venue-module Seat Mapping link. Central does not store each venue's URL yet,
// so this uses REACT_APP_VENUE_MODULE_URL or the venue LAN default. Only reachable from the venue network.
export const getVenueSeatMappingUrl = (projectName) =>
    `${process.env.REACT_APP_VENUE_MODULE_URL || 'https://exam.local:3001'}/${projectName}/seat-mapping`;

// Dummy values use the same font as real values, only a lighter color (no label or tooltip).
export const SampleValue = ({ children }) => (
    <Box component='span' sx={{ color: 'grey.500' }}>{children}</Box>
);
